import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

// 🟢 Get all coupons (with optional pagination & search)
export const getAllCoupons = createAsyncThunk(
  "admin/allCoupons",
  async ({ page = 1, limit = 10, searchData = "" } = {}, { rejectWithValue }) => {
    try {
      let url = `/coupon/all?page=${page}&limit=${limit}`;
      if (searchData) {
        url += `&search=${searchData}`;
      }
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🟢 Add new coupon
export const addCoupon = createAsyncThunk(
  "admin/addCoupon",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/coupon/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🟢 Edit existing coupon
export const editCoupon = createAsyncThunk(
  "admin/editCoupon",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/coupon/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🟢 Get single coupon details
export const getSingleCoupon = createAsyncThunk(
  "admin/singleCoupon",
  async (couponId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/coupon/${couponId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🟢 Delete a coupon
export const deleteCoupon = createAsyncThunk(
  "admin/deleteCoupon",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/coupon/delete/${selectedId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🔹 Initial State
const initialState = {
  couponData: [],
  singleCouponData: {},
};

// 🔹 Slice Definition
const couponSlice = createSlice({
  name: "couponSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllCoupons.fulfilled, (state, action) => {
      state.couponData = action.payload.data;
    });
    builder.addCase(getSingleCoupon.fulfilled, (state, action) => {
      state.singleCouponData = action.payload.data;
    });
  },
});

export default couponSlice.reducer;
